export default {
  header: "Preparation Setup is done",
  paragraph1: "1 - {{brandName}} now listed on koinz mobile application",
  paragraph2:
    "2 - {{brandName}} offline, In order to receive new order contact the cashier of your branch",
  paragraph3:
    "3. You can view ordering performance, orders history form the dashboard",
  btnLabel: "Go to Order history",
};
